import { Icon } from 'features/common/components/Icon';
import { Modal } from 'features/common/components/Modal';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
	.modal-content {
		background: ${({ theme }) => theme.colors.black};
		margin: 0;
		width: auto;
		box-shadow: none;
	}
`;

export const ModalContent = styled.div`
	padding: 24px;
	width: 500px;
	max-width: 100%;
	background: ${({ theme }) => theme.colors.black};
	border-radius: 12px;
`;

export const HeaderContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 24px;
	padding-bottom: 16px;
	border-bottom: 1px solid ${({ theme }) => theme.colors.whitePearl}22;
`;

export const Title = styled.h2`
	margin: 0;
	font-size: 18px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.whitePearl};
`;

export const FormContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	margin-bottom: 24px;
`;

export const InputContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const Label = styled.label`
	font-size: 13px;
	color: ${({ theme }) => theme.colors.whitePearl}99;
`;

export const Input = styled.input`
	background: transparent;
	border: 1px solid ${({ theme }) => theme.colors.whitePearl}33;
	border-radius: 8px;
	padding: 10px 12px;
	color: ${({ theme }) => theme.colors.whitePearl};
	font-size: 14px;
	width: 100%;

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.colors.whitePearl}66;
	}

	&::placeholder {
		color: ${({ theme }) => theme.colors.whitePearl}44;
	}
`;

export const ErrorMessage = styled.span`
	color: ${({ theme }) => theme.colors.red};
	font-size: 12px;
`;

export const ButtonsContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 12px;
	margin-top: 24px;
`;

export const Button = styled.button<{ variant?: 'secondary' }>`
	background: ${({ theme, variant }) => (variant === 'secondary' ? 'transparent' : theme.colors.whitePearl)};
	color: ${({ theme, variant }) => (variant === 'secondary' ? theme.colors.whitePearl : theme.colors.black)};
	border: 1px solid ${({ theme }) => theme.colors.whitePearl};
	padding: 8px 16px;
	border-radius: 20px;
	cursor: pointer;
	font-size: 13px;
	display: flex;
	align-items: center;
	gap: 8px;
	transition: all 0.2s ease;

	&:hover {
		background: ${({ theme, variant }) =>
			variant === 'secondary' ? theme.colors.whitePearl + '11' : theme.colors.whitePearl + 'dd'};
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;

export const LoadingIcon = styled(Icon)`
	animation: spin 1s linear infinite;

	@keyframes spin {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}
`;
